import H1 from "../../../Atoms/H1";
import ProjetEditor from "../ProjetEditor";
import { useTranslation } from "react-i18next";
import React from "react";

const PopB1 = (props) => {

    const { i18n } = useTranslation('common');

    return (<>
        <H1>{i18n.language === "fr" ? "Vos projets" : "Your projects"}</H1><br/>
        <span className="formtitle" style={{ marginBottom: '20px', marginTop: '40px' }}>{i18n.language === "fr" ? "Merci de compléter votre portfolio avec un minimum de 3 projets pour faire votre demande de rendez-vous. Attention : ceux-ci peuvent être diffusés auprès de l’entreprise pour aider celle-ci dans sa sélection de designers." : "Please complete your portfolio with a minimum of 3 projects to make your appointment request. Warning: these can be broadcast to the company to help it in its selection of designers."}</span>
        <ProjetEditor eventType="sde" projets={props.projets} setDeletedProjets={props.setDeletedProjets} setProjets={props.setProjets} />
    </>);
}

export default PopB1;